module.exports = __webpack_public_path__ + "static/media/sas-logo.30e678eb.png";